import { Component, Inject } from '@angular/core';
import { QuickLink } from 'src/app/models/quick-link-model';
import { KeyHandlerDirective } from '../../../directives/key-handler.directive';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { QuickLinkUpdate } from 'src/app/components/review/quick-links/quick-link-update';
import { Role } from '../../../models/role.model';

@Component({
    selector: 'lex-quick-link-management',
    templateUrl: './quick-link-management.component.html',
    styleUrls: ['./quick-link-management.component.scss'],
    standalone: false
})
export class QuickLinkManagementComponent extends KeyHandlerDirective {

  type: string;
  typePlural: string;
  shared: QuickLink[] = [];
  pinned: QuickLink[] = [];
  recent: QuickLink[] = [];
  update: QuickLinkUpdate;
  currentUserId: string;
  userRoles: Role[] = null;

  constructor(private dialogRef: MatDialogRef<QuickLinkManagementComponent>, @Inject(MAT_DIALOG_DATA) data) {
    super();
    this.type = data.type;
    this.typePlural = data.typePlural;
    const sharedAndPinned = data.links.getSharedAndPinnedDeepCopy();
    this.shared = sharedAndPinned.filter(ql => ql.isShared);
    this.pinned = sharedAndPinned.filter(ql => ql.isPinned && !ql.isShared);
    this.recent = data.links.getRecentDeepCopy();
    this.update = data.update;
    this.currentUserId = data.userId;
    this.userRoles = data.userRoles;
  }

  ok() {
    const all = this.shared.concat(this.pinned.concat(this.recent));
    all.forEach(link => {
      if (!this.isReadOnly(link)) {
        if (link.isShared) link.isPinned = true;

        this.update.updateLink(link).subscribe();
      }
    });

    this.dialogRef.close(all.filter(link => link.lifeCycle !== 1));
  }

  isReadOnly(link: QuickLink): boolean {
    return !this.userRoles.includes(Role.AccountFeatureSet) && link.createdById != this.currentUserId;
  }

  onClick(updatedLink: QuickLink, index: number, current: string) {
    if (updatedLink.isShared && updatedLink.isPinned) {
      this.shared.push(updatedLink);
    }
    else if (updatedLink.isPinned && !updatedLink.isShared)
      this.pinned.push(updatedLink);
    else {
      this.recent.push(updatedLink)
    }

    switch (current) {
      case 'Shared':
        this.shared.splice(index, 1);
        break;
      case 'Pinned':
        this.pinned.splice(index, 1);
        break;
      case 'Recent':
        this.recent.splice(index, 1);
        break;
    }

    this.shared.sort((a: QuickLink, b: QuickLink) => a.title > b.title ? 1 : -1);
    this.pinned.sort((a: QuickLink, b: QuickLink) => a.title > b.title ? 1 : -1);
    this.recent.sort((a: QuickLink, b: QuickLink) => a.dateTimeCreated < b.dateTimeCreated ? 1 : -1);
  }
}
